import slEventBus, { eventMetaMap } from '../../../../utils/slEventBus';

/**
 * @param {object} payload.cartData - The cart data after the gift is added
 */
export const onTrackAddVariationGift = async (payload) => {
  const { cartData } = payload;

  // for storefront sdk
  slEventBus.emit(eventMetaMap.cart.itemAdded.name, cartData);
};
